import React from 'react'

const initialState = {
  clientSdkId: '',
  scenarioId: '',
  language: '',
  referrer: ''
}

const ParametersContext = React.createContext(initialState)

export default ParametersContext
